import { createSlice, PayloadAction } from '@reduxjs/toolkit'
export interface AuthInfo {
    token?: string;
    username: string;
    expire: number; // Timestamp of expiration in second
}

export interface AppState {
    auth?: AuthInfo;
    selectedLanguages: Array<string>
}

export const initialState: AppState = {
   selectedLanguages:[]
}

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setAppAuth: (state, action: PayloadAction<AuthInfo>) => {
            state.auth = action.payload;
        },
        removeAuth:(state) =>{
            state.auth = undefined;
        },
        setSelectedLanguages(state,  action:PayloadAction<Array<string>>) {
            state.selectedLanguages = action.payload;
        },
        
    }
});

export const {
    setAppAuth,
    setSelectedLanguages,
    removeAuth
} = appSlice.actions;
  
export default appSlice.reducer;